export default __webpack_public_path__ + "static/media/ico-eye.0d5fd4ba.svg";